import React, { Component } from "react";
import Autolinker from 'autolinker';
import { func } from "prop-types";
import Draggable from 'react-draggable';
import { Row, Col, Button, Input } from "reactstrap";
import dompurify from 'dompurify';

import { isMobileOriPad, replaceProperUrlIfExists, getUserNameForSelectedLanguage} from "../../Utils/Utility";
import { getMessage } from "CONFIG/i18n";

import "./Chat.less";
// Assets
import chat_logo from "ASSETS/Images/header_center/ic_message_white.svg";
import img_minimize from "ASSETS/Images/ic_video_minimize.svg";
import download_img from "ASSETS/Images/ic_chat_download.svg";
import uuid from "uuid";
import moment from 'moment'

const sanitizer = dompurify.sanitize;
export default class Chat extends Component {
  static propTypes = {
    sendChatMessage: func
  };
  state = {
    position: {x: 0, y: 0},
    message: "",
    mobileChatBoxBounds: { top: -100, left: -100, right: 10, bottom: 0 },
    desktopChatBoxBounds: { top: -200, left: -900, right: 10, bottom: 0 },
    panning: false
  };

  constructor(props){
    super(props);
    this.setTimeOutBoundToChatWindow = this.setTimeOutBoundToChatWindow.bind(this);
  }

  componentDidMount() {
    var objDiv = document.getElementById("chatMessages");
    objDiv.scrollTop = objDiv.scrollHeight;
    window.addEventListener("resize", this.setTimeOutBoundToChatWindow);    
    window.document.body.addEventListener('touchmove', this.handlePreventTouchmoveWhenPanning, {passive: false});
    this.setBoundToChatWindow(()=>{
      let chatTextarea = document.getElementById("chatTextarea");
      chatTextarea && chatTextarea.focus();
    });
  }

  setTimeOutBoundToChatWindow(){
    this.setState({position: {x: 0, y: 0}},() => {
      setTimeout(() => this.setBoundToChatWindow(), 500)
    })
  }

  setBoundToChatWindow = (callback) => {
    var chatWindow = document.getElementById("chatWindow");
    if(chatWindow){
      let chatBoxBound = chatWindow.getBoundingClientRect()
      let windowHeight = window.innerHeight;
      let windowWidth = window.innerWidth;
      let desktopChatBoxBounds = {top:-(chatBoxBound.top), left: -(chatBoxBound.left), bottom:windowHeight-chatBoxBound.bottom, right:windowWidth-chatBoxBound.right}
      this.setState({desktopChatBoxBounds: desktopChatBoxBounds},() => {
        if(callback) callback()
      })
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.chatMessages !== this.props.chatMessages) {
      var objDiv = document.getElementById("chatMessages");
      objDiv.scrollTop = objDiv.scrollHeight;
    }
  }

  sendChatMessage = () => {
    if (this.state.message.trim()) {
      let messageToSend = replaceProperUrlIfExists(this.state.message)
      this.props.sendChatMessage(messageToSend.trim());
    }
    this.setState({
      message: ""
    },() => {
      let chatTextarea = document.getElementById("chatTextarea");
      chatTextarea && chatTextarea.focus();
    });
  };
  handleClose = () => {
    this.props.handleClose();
  };

  handleInputChange = event => {
    this.setState({
      message: event.target.value
    });
  };

  onKeyPress = event => {
    let chatTextarea = document.getElementById("chatTextarea");
    if (event.ctrlKey && event.keyCode == 13) {
      // Ctrl-Enter pressed
      chatTextarea.focus();
      chatTextarea.value = chatTextarea.value + "\n";
      chatTextarea.scrollTop = chatTextarea.scrollHeight;
    } else if (event.keyCode === 13) {
      event.preventDefault();
      this.sendChatMessage();
    }
  };
  
  onDragHandler = (e, ui) =>{
    const {x, y} = this.state.position;
    this.setState({
      position: {
        x: x + ui.deltaX,
        y: y + ui.deltaY,
      }
    });
    document.body.style.cursor="grabbing"
  }

  handlePreventTouchmoveWhenPanning = (event) => {
    if (this.state.panning) {
      event.preventDefault();
    }
  };

  componentWillUnmount () {
    window.removeEventListener("resize", this.setTimeOutBoundToChatWindow);    
    window.document.body.removeEventListener('touchmove', this.handlePreventTouchmoveWhenPanning, {passive: false});
  }

  /*
    About onTouchStart/onClick event of img tag under Draggable(react-draggable) tag:
    Due to the internal processing of react-draggable, if onTouchStart event occurs, onClick event does not occur.
    Therefore, add the same process to both onTouchStart/onClick so that the process can be performed in either event.
  */
  render() {
    const { chatMessages } = this.props;
    var autolinker = new Autolinker({stripPrefix: false, phone: false});
    return this.props.chatPopOver ? (
      <Draggable 
        onStart={
          e => {
            this.setState({ panning: true})
          }
        } 
        onStop={e => {
          this.setState({ panning: false})
          document.body.style.cursor="auto"
        }} 
        position={{x: this.state.position.x, y: this.state.position.y}}
        cancel={".avoidDrag"} 
        onDrag={this.onDragHandler} 
        bounds={this.state.desktopChatBoxBounds}>
        <div className="positioningChat" id="chatWindow">
          <div className="pt-xs-1 pt-md-2 chatHeader">
            <img src={chat_logo} alt="chat" />
            <label className="chatTitle pl-2 mb-0 mb-lg-2">
              {getMessage("CHAT")}
            </label>
            <img
              src={img_minimize}
              alt="minimize"
              title={getMessage("TOOLTIP_CHAT_MINIMIZE")}
              className="img-fluid cursorPointer float-right blinkImg"
              onClick={() => {
                this.handleClose();
              }}
              onTouchStart={() => {
                this.handleClose();
              }}
            />
            {chatMessages && chatMessages.length != 0 && this.props.isChatDownloadAllowed ? (
              <img
                src={download_img}
                alt="download"
                title={getMessage("DOWNLOAD")}
                className={
                  chatMessages && chatMessages.length != 0
                    ? "img-fluid cursorPointer float-right mx-1 blinkImg"
                    : "img-fluid cursorDisabled float-right mx-1 blinkImg"
                }
                onClick={
                  chatMessages && chatMessages.length != 0
                    ? this.props.downloadChatMessages
                    : () => {}
                }
                onTouchStart={
                  chatMessages && chatMessages.length != 0
                    ? this.props.downloadChatMessages
                    : () => {}
                }
              />
            ) : null}
          </div>
          <div className="avoidDrag">
            <div id="chatMessages" className="chatMessages px-lg-1 pt-lg-1">
              {_.map(chatMessages, messageDetails => {
                let d = new Date(messageDetails.timestamp);
                let time = moment(d).format("HH:mm");
                let senderName = '';
                if(this.props.organiserParticipantId === messageDetails.participantId) {
                  senderName = getUserNameForSelectedLanguage(this.props.language, messageDetails.sender);
                } else {
                  senderName = getMessage(messageDetails.sender);
                }
                return messageDetails.participantId === this.props.participantId || messageDetails.ownMessage? (
                  <Row className="w-100 d-inline-block m-0" key={uuid.v4()}>
                    <div className="mx-1">
                      <div className="chatMsg2 float-right">
                        <Col className="text-left p-0">
                          <span className="msgAndTime1">
                            <p className="msgTime">
                              { time }
                            </p> 
                            <p className="msg2 p-2 m-0"
                              dangerouslySetInnerHTML={{__html:sanitizer(autolinker.link(messageDetails.message), {ADD_ATTR: ['target']})}} />  
                          </span>
                        </Col>
                      </div>
                    </div>
                  </Row>
                ) : (
                  <Row className="w-100 d-inline-block m-0" key={uuid.v4()}>
                    <div className="chatMsg">
                      <Col lg="12" className="px-1">
                        <p className="msgName mb-1 mt-1">
                          { senderName }
                        </p>
                      </Col>
                      <Col lg="12" className="px-1">
                        <span className="msgAndTime2">
                          <p className="msg text-left float-left p-2 mb-2"
                            dangerouslySetInnerHTML={{__html:sanitizer(autolinker.link(messageDetails.message), {ADD_ATTR: ['target']})}} />
                          <p className="msgTime2">
                            { time }
                          </p>
                        </span>
                      </Col>
                    </div>
                  </Row>
                );
              })}
            </div>
            <div className="sendMessageSection">
              <Row>
                <Col lg="9" xs="8" className="pr-0">
                  <Input
                    id="chatTextarea"
                    type="textarea"
                    rows="1"
                    cols="24"
                    name="msg"
                    className="inputMsg "
                    placeholder={getMessage("ENTER_MESSAGE")}
                    value={this.state.message}
                    onChange={this.handleInputChange}
                    onKeyDown={this.onKeyPress}
                    autoFocus={true}
                    maxLength={4096}
                  />
                </Col>
                <Col lg="3" xs="4" className="text-lg-right text-md-right pl-1">
                  <Button className="sendBtn" onClick={this.sendChatMessage}>
                    {getMessage("SEND")}
                  </Button>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </Draggable>
    ) : null;
  }
}
